<div class="popover-wrapper">
    <div class="popover-header">{{title}}</div>
    <div class="layout-container">
        <div class="content">
            <nb-tabset>
                <nb-tab tabTitle="Properties" class="inner-tab">
                    <nb-tabset kveVerticalTabs>
                        <nb-tab [tabIcon]="widthIconConfig" tabTitle="Width">
                            <div class="options-container">
                                <div class="minor-options">
                                    <div class="options">
                                        <kve-border-input [field]="field" [type]="'width'" [color]="color" (borderChange)="onBorderChange($event)" [borderString]="borderString"></kve-border-input>
                                    </div>
                                    <!-- <div class="options">
                                        <div class="selections">
                                            <div class="custom-slider">
                                                <ngx-slider
                                                    [(value)]="value"
                                                    [options]="options"
                                                    (userChangeStart)="onUserChangeStart($event)"
                                                    (userChange)="onUserChange($event)"
                                                    (userChangeEnd)="onUserChangeEnd($event)">
                                                </ngx-slider>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </nb-tab>
                        <nb-tab [tabIcon]="radiusIconConfig" tabTitle="Radius">
                            <div class="options-container">
                                <div class="minor-options">
                                    <div class="options">
                                        <kve-border-input [field]="field" [type]="'radius'" (borderRadiusChange)="onBorderRadiusChange($event)" [borderRadiusString]="borderRadiusString"></kve-border-input>
                                    </div>
                                </div>
                                <!-- <div class="title-container">
                                    <nb-actions size="medium">
                                        <nb-action title="Border Radius"
                                        class="popover-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-border-radius" width="100%" height="100%" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                            <path d="M4 12v-4a4 4 0 0 1 4 -4h4" />
                                            <line x1="16" y1="4" x2="16" y2="4.01" />
                                            <line x1="20" y1="4" x2="20" y2="4.01" />
                                            <line x1="20" y1="8" x2="20" y2="8.01" />
                                            <line x1="20" y1="12" x2="20" y2="12.01" />
                                            <line x1="4" y1="16" x2="4" y2="16.01" />
                                            <line x1="20" y1="16" x2="20" y2="16.01" />
                                            <line x1="4" y1="20" x2="4" y2="20.01" />
                                            <line x1="8" y1="20" x2="8" y2="20.01" />
                                            <line x1="12" y1="20" x2="12" y2="20.01" />
                                            <line x1="16" y1="20" x2="16" y2="20.01" />
                                            <line x1="20" y1="20" x2="20" y2="20.01" />
                                        </svg>
                                    </nb-action>
                                </nb-actions>
                                </div>
                                <div class="options-container">
                                    <div class="options">
                                        <div class="vertical-slider">
                                            <ngx-slider
                                                [(value)]="radiusValue"
                                                [options]="radiusOptions"
                                                (userChangeStart)="onVertUserChangeStart($event)"
                                                (userChange)="onVertUserChange($event)"
                                                (userChangeEnd)="onVertUserChangeEnd($event)">
                                            </ngx-slider>
                                        </div>   
                                    </div>
                                </div> -->
                            </div>
                        </nb-tab>
                        <nb-tab [tabIcon]="colorIconConfig" tabTitle="Color">
                            <color-sketch [presetColors] ="colors" [color]="color" (onChangeComplete)="handleChangeComplete($event)" (onChange)="handleColorPick($event)"></color-sketch>
                        </nb-tab>
                    </nb-tabset>        
                </nb-tab>
                <nb-tab tabTitle="Presets" class="inner-tab">
                    <div class="options-container">
                        <div class="options">
                            <div *ngFor="let borderClass of borderRadiusClasses" class="option-wrap">
                                <div class="preset-option">
                                    <div [ngClass]="[borderBaseClass,'option',borderClass?.class,selectedWidth?.class,borderClass?.class == selectedRadiusClass ? 'selected': 'unselected']" (click)="onBorderSelect(borderClass)"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nb-tab>
            </nb-tabset>
        </div>
    </div>
</div>

